import { Moon, Sun } from "lucide-react";
import { ROUTES, TID } from "@/data/site";

const PricingCard = ({ route }) => {
  return (
    <article
      data-testid={TID.pricingCard(route.id)}
      className="relative group rounded-3xl overflow-hidden glass lift"
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={route.image}
          alt={route.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a1830] via-[#0a1830]/30 to-transparent" />
        <div className="absolute bottom-4 left-5 right-5">
          <div className="text-[0.7rem] uppercase tracking-[0.2em] text-foreground/70">
            Taxi Transfer
          </div>
          <h3 className="font-display text-2xl mt-1 leading-tight">
            {route.title}
          </h3>
        </div>
      </div>

      <div className="p-6">
        <p className="text-sm text-foreground/70 leading-relaxed">
          {route.subtitle}
        </p>

        <div className="mt-5 grid grid-cols-2 gap-3">
          <div className="rounded-2xl bg-white/5 border border-white/5 p-4">
            <div className="flex items-center gap-1.5 text-[0.7rem] uppercase tracking-[0.18em] text-foreground/60">
              <Sun className="h-3.5 w-3.5" /> Day
            </div>
            <div className="mt-2 font-display text-4xl price-day">
              €{route.day}
            </div>
          </div>
          <div className="rounded-2xl bg-gold/8 border border-gold/20 p-4">
            <div className="flex items-center gap-1.5 text-[0.7rem] uppercase tracking-[0.18em] text-gold/80">
              <Moon className="h-3.5 w-3.5" /> Night
            </div>
            <div className="mt-2 font-display text-4xl price-night">
              €{route.night}
            </div>
          </div>
        </div>

        <div className="mt-4 text-[0.72rem] uppercase tracking-[0.16em] text-foreground/55">
          Night hours: {route.nightHours}
        </div>
      </div>
    </article>
  );
};

const Pricing = () => {
  return (
    <section
      id="transfers"
      data-testid={TID.pricingSection}
      className="relative bg-aegean grain pt-4 sm:pt-6 pb-20 sm:pb-28"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ROUTES.map((r) => (
            <PricingCard key={r.id} route={r} />
          ))}
        </div>

        <div className="mt-10 text-sm text-foreground/55">
          * All prices are total per vehicle, not per passenger. Tolls and Athens Airport
          parking fees are already included.
        </div>
      </div>
    </section>
  );
};

export default Pricing;
